import { CategoryModel } from '@modules/category/category-model';

const fields = new CategoryModel().fields();

export default [
  fields.name,
  fields.label,
];
